import { render, staticRenderFns } from "./GuidedDocumentInformationSection.vue?vue&type=template&id=a7129896&scoped=true&"
import script from "./GuidedDocumentInformationSection.vue?vue&type=script&lang=js&"
export * from "./GuidedDocumentInformationSection.vue?vue&type=script&lang=js&"
import style0 from "./GuidedDocumentInformationSection.vue?vue&type=style&index=0&id=a7129896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7129896",
  null
  
)

export default component.exports